// extracted by mini-css-extract-plugin
export var blue = "_3o-g";
export var brand = "_3o-c";
export var darkGrey = "_3o-f";
export var disabled = "_3o-6";
export var disabledSubtle = "_3o-7";
export var error = "_3o-8";
export var green = "_3o-h";
export var grey = "_3o-e";
export var icon = "_3o-0";
export var inherit = "_3o-b";
export var lightGrey = "_3o-d";
export var orange = "_3o-j";
export var pink = "_3o-l";
export var primary = "_3o-1";
export var purple = "_3o-m";
export var quaternary = "_3o-4";
export var quinary = "_3o-5";
export var red = "_3o-k";
export var secondary = "_3o-2";
export var success = "_3o-a";
export var tertiary = "_3o-3";
export var warning = "_3o-9";
export var white = "_3o-n";
export var yellow = "_3o-i";